import React, { FC } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { makeStyles } from '@material-ui/core/styles';
import styles from './styles';

export interface QuillRichtextDisplayProps {
  html: string | null;
}

const useStyles = makeStyles(styles, { name: 'RaRichTextInput' });
const QuillRichtextDisplay: FC<QuillRichtextDisplayProps> = ({ html }) => {
  useStyles();
  return (
    <div className="ql-editor">
      {ReactHtmlParser(html)}
    </div>
  );
};

export default QuillRichtextDisplay;
